// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-collapse-content {\n  overflow: unset;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-top: 1px solid #d9d9d9;\n}\n.ant-modal-header{\n  text-align: center;\n}\n.ant-table-pagination {\n  margin-right: 15px !important;\n}\n.anticon-close-circle svg {\n  display: block!important;\n}\n\n\n\n", ""]);
// Exports
module.exports = exports;
